import React from "react";
import "./ToggleSwitch.css";

export const ToggleSwitch = ({
  checked,
  onChange,
  disabled = false,
  ariaLabel,
  className = "",
}) => {
  const handleClick = () => {
    if (disabled) return;
    onChange?.(!checked);
  };

  return (
    <button
      type="button"
      className={`bb-toggle-switch ${checked ? "bb-toggle-switch-on" : "bb-toggle-switch-off"} ${className}`}
      onClick={handleClick}
      disabled={disabled}
      aria-pressed={checked}
      aria-label={ariaLabel}
    >
      <span className="bb-toggle-knob" />
    </button>
  );
};
